import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ZardButtonComponent } from '@solvace/zard/shared/components/button';
import { ZardDialogRef } from '@solvace/zard/shared/components/dialog/dialog-ref';
import { Z_MODAL_DATA } from '@solvace/zard/shared/components/dialog/dialog.service';

export interface SvzWarningDialogData {
  text: string;
  title?: string;
  buttonText?: string;
}

@Component({
  selector: 'svz-warning-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ZardButtonComponent],
  templateUrl: './svz-warning-dialog.component.html',
})
export class SvzWarningDialogComponent {
  private readonly dialogRef = inject(ZardDialogRef<SvzWarningDialogComponent, void>);
  private readonly data = inject<SvzWarningDialogData>(Z_MODAL_DATA);

  protected readonly title = this.data?.title ?? 'Atenção';
  protected readonly text = this.data?.text;
  protected readonly buttonText = this.data?.buttonText ?? 'OK';

  closeDialog(): void {
    this.dialogRef.close();
  }
}
